/* eslint-disable max-len */
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
// import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';

// import DashboardView from 'src/views/reports/DashboardView';
// import CustomView from 'src/views/reports/CustomView';
// import DailyView from 'src/views/reports/DailyView';
// import LoginView from 'src/views/auth/LoginView';
// import NotFoundView from 'src/views/errors/NotFoundView';
// import HomeView from 'src/views/HomeView'; // no access homepage

// for Dev
// import DevDashboardView from 'src/views/HomeView/--draft';
// import DashboardWithFilterViewTest from 'src/views/reports/DashboardWithFilterView/DashboardWithFilterViewTest';

import { BASE_URL } from 'src/config';

// const ComparisonDashboardView = lazy(() => import('src/views/reports/ComparisonDashboardView'));
// const DashboardView = lazy(() => import('src/views/reports/DashboardView'));
// const DashboardWithFilterView = lazy(() => import('src/views/reports/DashboardWithFilterView'));
// const InteractiveDashboardView = lazy(() => import('src/views/reports/InteractiveDashboardView'));
// const CustomView = lazy(() => import('src/views/reports/CustomView'));
// const DailyView = lazy(() => import('src/views/reports/DailyView'));
// const LoginView = lazy(() => import('src/views/auth/LoginView'));
// const NotFoundView = lazy(() => import('src/views/errors/NotFoundView'));
// const FormApprovalView = lazy(() => import('src/views/auth/FormApprovalView'));
// const TalentSummaryView = lazy(() => import('src/views/auth/TalentSummaryView'));
const HomeView = lazy(() => import('src/views/HomeView')); // no access homepage

// const dashboards = [
//   {
//     children: [
//       { key: 'subs_services', label: 'Subs Services' },
//       { key: 'daily_graphs', label: 'Daily Subs Service Graphs' },
//       { key: 'subs_summary', label: 'Summary Table' },
//       { key: 'opt_report', label: 'Optimization Report' },
//       { key: 'subs_monthly_summary', label: 'Monthly Summary' },
//       { key: 'google_ads_report', label: 'Google Ads Report' },
//     ],
//     key: 'subscription_services',
//     label: 'Subscription Services'
//   },
//   {
//     children: [
//       { key: 'wallet_codes', label: 'Wallet Codes Data' },
//       { key: 'wallet_codes_uvr', label: 'User Value Reports' },
//       { key: 'wallet_codes_campaign', label: 'Ad Campaign Report' },
//       { key: 'wallet_codes_monthly_summary', label: 'Monthly Summary' },
//       { key: 'wallet_codes_ppoints', label: 'P-points' }
//     ],
//     key: 'wallet_codes',
//     label: 'Wallet Codes'
//   },
//   {
//     children: [
//       { key: 'dsdp', label: 'DSDP Data' },
//       { key: 'dsdp_brands', label: 'DSDP Brands' },
//       { key: 'dsdp_monthly_summary', label: 'Monthly Summary' },
//     ],
//     key: 'dsdp',
//     label: 'DSDP'
//   },
//   {
//     children: [
//       { key: 'subs_financial_metrics', label: 'Subs Services Financial Metrics' },
//       { key: 'wallet_codes_financial_metrics', label: 'Wallet Codes Financial Metrics' }
//     ],
//     key: 'financial_metrics',
//     label: 'Financial and Marketing Metrics'
//   },
//   {
//     key: 'general_overview',
//     label: 'General Overview',
//     children: [
//       {
//         key: 'general_overview',
//         label: 'General Overview'
//       }
//     ]
//   }
//   // {
//   //   children: [
//   //     { key: 'new', label: 'New Dashboard' }
//   //   ],
//   //   key: 'new',
//   //   label: 'NEW'
//   // },
// ];

// eslint-disable-next-line no-unused-vars
const routes = (isLoggedIn, userDashboard, homepage) => [
  // {
  //   path: `${BASE_URL}/app`,
  //   element: isLoggedIn ? <DashboardLayout /> : <Navigate to={`${BASE_URL}/`} />,
  //   children: [
  //     { path: 'custom_redirect', children: [{ path: '/', element: <CustomView /> }, { path: ':id', element: <CustomView /> }] },

  //     { path: 'subs_services', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'subs_services')) > -1 ? <DashboardView dashboard={dashboards[0].children.find((d) => d.key === 'subs_services')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'daily_graphs', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'daily_graphs')) > -1 ? <DailyView dashboard={dashboards[0].children.find((d) => d.key === 'daily_graphs')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'subs_summary', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'subs_summary')) > -1 ? <DashboardView dashboard={dashboards[0].children.find((d) => d.key === 'subs_summary')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'opt_report', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'opt_report')) > -1 ? <InteractiveDashboardView dashboard={dashboards[0].children.find((d) => d.key === 'opt_report')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'subs_monthly_summary', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'subs_monthly_summary')) > -1 ? <DashboardWithFilterView dashboard={dashboards[0].children.find((d) => d.key === 'subs_monthly_summary')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'google_ads_report', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'google_ads_report')) > -1 ? <DashboardWithFilterView dashboard={dashboards[0].children.find((d) => d.key === 'google_ads_report')} /> : <Navigate to={`${BASE_URL}/404`} /> },

  //     { path: 'wallet_codes', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'wallet_codes')) > -1 ? <DashboardWithFilterView dashboard={dashboards[1].children.find((d) => d.key === 'wallet_codes')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'wallet_codes_uvr', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'wallet_codes_uvr')) > -1 ? <ComparisonDashboardView dashboard={dashboards[1].children.find((d) => d.key === 'wallet_codes_uvr')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'wallet_codes_campaign', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'wallet_codes_campaign')) > -1 ? <DashboardWithFilterView dashboard={dashboards[1].children.find((d) => d.key === 'wallet_codes_campaign')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'wallet_codes_monthly_summary', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'wallet_codes_monthly_summary')) > -1 ? <DashboardWithFilterView dashboard={dashboards[1].children.find((d) => d.key === 'wallet_codes_monthly_summary')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'wallet_codes_ppoints', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'wallet_codes_ppoints')) > -1 ? <DashboardWithFilterView dashboard={dashboards[1].children.find((d) => d.key === 'wallet_codes_ppoints')} /> : <Navigate to={`${BASE_URL}/404`} /> },

  //     { path: 'dsdp', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'dsdp')) > -1 ? <DashboardView dashboard={dashboards[2].children.find((d) => d.key === 'dsdp')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'dsdp_brands', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'dsdp_brands')) > -1 ? <DashboardWithFilterView dashboard={dashboards[2].children.find((d) => d.key === 'dsdp_brands')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'dsdp_monthly_summary', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'dsdp_monthly_summary')) > -1 ? <DashboardView dashboard={dashboards[2].children.find((d) => d.key === 'dsdp_monthly_summary')} /> : <Navigate to={`${BASE_URL}/404`} /> },

  //     { path: 'subs_financial_metrics', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'subs_financial_metrics')) > -1 ? <DashboardWithFilterView dashboard={dashboards[3].children.find((d) => d.key === 'subs_financial_metrics')} /> : <Navigate to={`${BASE_URL}/404`} /> },
  //     { path: 'wallet_codes_financial_metrics', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'wallet_codes_financial_metrics')) > -1 ? <DashboardWithFilterView dashboard={dashboards[3].children.find((d) => d.key === 'wallet_codes_financial_metrics')} /> : <Navigate to={`${BASE_URL}/404`} /> },

  //     { path: 'general_overview', element: userDashboard.length > 0 && userDashboard.findIndex((d) => d.children.some((item) => item.key === 'general_overview')) > -1 ? <DashboardWithFilterView dashboard={dashboards[4].children.find((d) => d.key === 'general_overview')} /> : <Navigate to={`${BASE_URL}/404`} /> },

  //     { path: 'home', element: (userDashboard.length > 0 && homepage ? <Navigate to={`${BASE_URL}/app/${homepage}`} /> : <HomeView />) },
  //     { path: '*', element: <Navigate to={`${BASE_URL}/404`} /> }
  //   ]
  // },
  {
    path: `${BASE_URL}/`,
    element: <MainLayout />,
    children: [
      // { path: '/', element: !isLoggedIn ? <LoginView /> : <Navigate to={`${BASE_URL}/app/home`} /> },
      { path: '/', element: <HomeView /> },
      // { path: 'form_approval/:id', element: <FormApprovalView /> },
      // { path: 'talent_summary/:id', element: <TalentSummaryView /> },
      // { path: '404', element: <NotFoundView /> },
      { path: '*', element: <Navigate to={`${BASE_URL}/`} /> }
    ]
  }
];

export default routes;
